import React, { memo } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Lock, ShieldCheck, CreditCard } from 'lucide-react';
export function FinalCTA() {
  const {
    currentPrice,
    checkoutLink
  } = useCountdown();
  return <section className="bg-marron py-16 md:py-24 px-4 text-white border-t-4 border-terracota" data-id="element-38">
      <div className="max-w-4xl mx-auto text-center" data-id="element-39">
        <h2 className="text-[32px] md:text-[48px] font-playfair font-bold mb-8" data-id="element-40">
          🎯 DOS OPCIONES
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-41">
          <div className="bg-white/5 border border-white/10 p-6 md:p-8 rounded-2xl" data-id="element-42">
            <h3 className="text-xl font-montserrat font-bold text-rojo mb-4" data-id="element-43">
              Opción A:
            </h3>
            <p className="text-crema/80" data-id="element-44">
              Seguir comprando el colágeno en polvo de $60 al mes. Seguir
              aplicando cremas que no penetran la dermis. Seguir viendo ese
              espejo de las 11 PM con resignación.
            </p>
          </div>
          <div className="bg-verde/20 border border-verde/40 p-6 md:p-8 rounded-2xl" data-id="element-45">
            <h3 className="text-xl font-montserrat font-bold text-verde mb-4" data-id="element-46">
              Opción B:
            </h3>
            <p className="text-crema" data-id="element-47">
              Por ${currentPrice} USD hoy — menos que un café y un pan — darle a
              tu cuerpo el sistema completo para fabricar colágeno real desde
              adentro.
            </p>
          </div>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-48">
          <p className="text-xl md:text-2xl font-playfair italic text-terracota mb-8" data-id="element-49">
            "Tu piel tiene memoria biológica. Hoy puedes darle las instrucciones
            para recordar cómo ser joven."
          </p>

          <a href={checkoutLink} className="btn-primary w-full h-[64px] md:h-[80px] text-[18px] md:text-[22px] mb-6 shadow-2xl" data-id="element-50">
            ✅ ACCEDER AHORA POR ${currentPrice} USD →
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-crema/60 mb-8" data-id="element-51">
            <span className="flex items-center" data-id="element-52">
              <Lock className="w-4 h-4 mr-1" data-id="element-53" /> SSL Seguro
            </span>
            <span className="flex items-center" data-id="element-54">
              <CreditCard className="w-4 h-4 mr-1" data-id="element-55" /> Visa / Mastercard / PayPal
            </span>
            <span className="flex items-center" data-id="element-56">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-57" /> Garantía 30 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}